import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Avatar,
  Box,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import type { Challenge } from '../../../interfaces/interfaces';
import { createDisplayLink } from '../../../services/helper';
import VyButton from '../../common/VyButton';
import { VyExportButton } from '../../common/VyExportButton';
import VyTooltip from '../../common/VyTooltip';

interface ParticipantsModalInterface {
  submissions: any[];
  challenge: Challenge;
}

const ParticipantsModal = ({ submissions = [], challenge }: ParticipantsModalInterface) => {
  const { t } = useTranslation(['account']);
  const [open, setOpen] = useState(-1);
  const [isRaffling, setIsRaffling] = useState(false);
  const [winnerId, setWinnderId] = useState(challenge.winner);

  const raffle = () => {
    setIsRaffling(true);
    axios
      .post(`/challenge/raffle/${challenge._id}`)
      .then(({ data }) => {
        setIsRaffling(false);
        setWinnderId(data.data);
      })
      .catch((err) => console.error(err));
  };
  return (
    <div>
      <div style={{ maxHeight: '50vh', overflow: 'hidden', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableBody>
              {submissions.map((s, i) => (
                <>
                  <TableRow className={winnerId === s.user._id ? 'bg-emerald-200' : ''}>
                    <TableCell>
                      <IconButton aria-label="expand row" style={{ outline: 'none' }} size="small" onClick={() => (open === i ? setOpen(-1) : setOpen(i))}>
                        {open === i ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      <Avatar src={s.user?.avatar?._id ? createDisplayLink(s.user.avatar) : undefined} style={{ width: '25px', height: '25px', float: 'left' }}>
                        {s.user?.name?.charAt(0)?.toUpperCase()}
                      </Avatar>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {s.user.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {s.user.email}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                      <Collapse in={open === i} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                          <Typography variant="h6" gutterBottom component="div">
                            {t('account:challenges.tasks')}
                          </Typography>
                          <Table size="small" aria-label="Reports" className="bg-slate-200 m-2">
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <b>{t('account:challenges.name')}</b>
                                </TableCell>
                                <TableCell>
                                  <b>{t('account:challenges.goal')}</b>
                                </TableCell>
                                <TableCell align="right">
                                  <b>{t('account:challenges.score')}</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {s.challenge.tasks.map((task: any) => (
                                <TableRow key={task._id}>
                                  <TableCell component="th" scope="row">
                                    {task.name}
                                  </TableCell>
                                  <TableCell>{task.goal}</TableCell>
                                  <TableCell align="right">{Math.round(s.score.score[task._id] * 10) / 10}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="w-full grid place-items-center my-4">
        {!isRaffling ? (
          <>
            <VyTooltip title={t('account:challenges.raffle:tooltip')}>
              <VyButton color="secondary" disabled={!!winnerId} onClick={raffle}>
                {t('account:challenges.raffle')}
              </VyButton>
            </VyTooltip>
            <VyExportButton
              className="mt-2"
              axiosMethod={'GET'}
              csvURL={`/challenge/submissions/${challenge._id}?resType=csv`}
              xlsxURL={`/challenge/submissions/${challenge._id}?resType=xlsx`}
            />
          </>
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
};
export default ParticipantsModal;
